import request from '../../../../shared/request'
import queryString from 'qs'
import _ from 'lodash'
import moment from 'moment'

export function getJobList(filters) {
  const qs = queryString.stringify(filters)
  return request(`/reports/jobs/site-work-schedules/job-list?${qs}`)
}

export function getFullReport(filters) {
  const params = _.omit(filters, 'date_range')

  if (filters.date_range[0] && filters.date_range[1]) {
    params.startDate = moment(filters.date_range[0]).format('YYYY-MM-DD')
    params.endDate = moment(filters.date_range[1]).format('YYYY-MM-DD')
  }

  const qs = queryString.stringify(params)
  return request(`/reports/jobs/site-work-schedules/full-report?${qs}`)
}



// WEBPACK FOOTER //
// ./src/redux/api/reports/jobs/siteWorkSchedulesReport.js